<div [formGroup]="form">
  <label [for]="settings.idName" [ngClass]="{ 'text-danger': errorMessage }">{{
    settings.label
  }}</label>
  <tooltip
    [title]="'Enter Your ' + settings.label"
    placement="right"
    delay="200"
  ></tooltip>

  <textarea
    type="text"
    [rows]="settings.rows"
    [cols]="settings.cols"
    [name]="settings.name"
    [class]="settings.className"
    [readonly]="settings.readonly"
    [ngClass]="{ 'border-danger': errorMessage }"
    [placeholder]="settings.placeholder"
    [id]="settings.idName"
    [formControlName]="settings.formControlName"
    (change)="valueChange()"
    [value]="settings.value"
    (paste)="onPaste($event, '')"
    (focus)="onFocusEvent($event)"
    (click)="onClickEvent($event)"
    (blur)="onBlurEvent($event)"
    (keyup.enter)="onEnterEvent($event)"
  ></textarea>
  <p *ngIf="errorMessage" class="text-danger">{{ errorMessage }}</p>
</div>
